export default __webpack_public_path__ + "static/media/7.cba1237d.svg";